import CourseListItems from './CourseListItems';

export default CourseListItems;
